var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.link)?_c('a',{staticClass:"checkbox-label__link",attrs:{"href":_vm.link,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" "+_vm._s(_vm.anchor)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }